export const pageHeaderDataHooks = {
  container: 'page-header-container',
  primaryTitle: 'page-header-primary-title',
  secondaryTitle: 'page-header-secondary-title',
  description: 'page-header-description',
};
